import {
  clearTerminalResumeSuppression,
  isTerminalResumeSuppressed,
  suppressTerminalResume,
} from '../app/providers/terminal-resume-suppress';
import { useChatTurnInterruptedStore } from '../store/chat-turn-interrupted-store';

export function beginCopilotGraphTurn(chatId: string): void {
  clearTerminalResumeSuppression(chatId);
}

export function revertUnstartedCopilotGraphTurn(chatId: string): void {
  suppressTerminalResume(chatId);
}

export async function sendCopilotGraphMessage<T>({
  chatId,
  send,
}: {
  chatId: string;
  send: (lifecycle: { markStarted: () => void }) => T | Promise<T>;
}): Promise<T> {
  const wasSuppressed = isTerminalResumeSuppressed(chatId);
  let started = false;

  beginCopilotGraphTurn(chatId);

  try {
    return await send({
      markStarted: () => {
        started = true;
      },
    });
  } catch (error) {
    if (wasSuppressed && !started) {
      revertUnstartedCopilotGraphTurn(chatId);
    }

    throw error;
  }
}

export function prepareChatUserTurn({
  chatId,
  clearNeoResumeSuppression,
  clearComposerLoadingSuppression,
}: {
  chatId: string;
  clearNeoResumeSuppression: (chatId: string) => void;
  clearComposerLoadingSuppression: (chatId: string) => void;
}): void {
  clearNeoResumeSuppression(chatId);
  clearComposerLoadingSuppression(chatId);
  useChatTurnInterruptedStore.getState().setTurnInterrupted(chatId, false);
}
